export const calculateSharePercentage = (availableTokens: number, totalTokens: number): number =>
    ((totalTokens - availableTokens) / totalTokens) * 100;

export const calculateRemainingPrice = (totalPrice: number, totalTokens: number, availableTokens: number, nominalValue: number): number =>
    totalPrice - (totalTokens - availableTokens) * nominalValue;
